import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, localize, extend,
} from 'vee-validate';
import ptBr from 'vee-validate/dist/locale/pt_BR.json';
import {
  required,
  email,
  min,
  max,
  length,
  confirmed,
} from 'vee-validate/dist/rules';
import i18n from '@/plugins/i18n';

// navigator.language
localize('ptBr', ptBr);

extend('required', required);
extend('email', {
  ...email,
  message: i18n.t('errors.mail_invalid'),
});
extend('min', min);
extend('max', max);
extend('length', length);
extend('confirmed', confirmed);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
